<template>
  <div class='single-chart-circle'>
    <svg viewBox="0 0 36 36" class="circular-chart">
      <path :stroke-width='configOrDefault("width", "1.3")' :stroke='configOrDefault("backgroundStroke", "#eeeeee")' class="circle-bg"
        d="M18 3
          a 15 15 0 0 1 0 30
          a 15 15 0 0 1 0 -30"
      />
      <path :stroke-width='configOrDefault("width", "1.3")' :stroke='configOrDefault("stroke", "#ffaabb")' :class="{circle: true, ready: ready}"
        :stroke-dasharray="arcStroke()"
        d="M18 3
          a 15 15 0 0 1 0 30
          a 15 15 0 0 1 0 -30"
      />
      <text v-if='configOrDefault("showPercent", true)' x="18" y="20.5" :font-size='titleFontSize' :fill='configOrDefault("titleColor", "#ababab")' class="percentage" :style='{fill: configOrDefault("titleColor", "#ababab")}'>{{title}}</text>
      <text x="18" y="25" v-if='configOrDefault("showText", true)' :fill='configOrDefault("textColor", "#ababab")' :font-size='textFontSize' class='helptext'>{{text}}</text>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      default () { return 0 }
    },
    config: {
      type: Object,
      default () { return {} }
    },
    title: {
      type: String,
      default () { return '' }
    },
    text: {
      type: String,
      default () { return '' }
    }
  },
  computed: {
    titleFontSize () {
      if (this.config.displayAs === 'percentage') {
        return '65%'
      } else {
        return '50%'
      }
    },
    textFontSize () {
      return '17%'
    }
  },
  data () {
    return {
      ready: false
    }
  },
  methods: {
    arcStroke () {
      return this.percentVal() + ', 100'
    },
    percentVal () {
      return (this.progress * 100)
    },
    configOrDefault (key, defaultValue) {
      if (typeof this.config[key] !== 'undefined') {
        return this.config[key]
      } else {
        return defaultValue
      }
    }
  },
  watch: {
    progress (oldVal, newVal) {
      this.ready = true
    }
  }
}
</script>
<style lang='scss' scoped>
.single-chart-circle {
  width: 100%;
  justify-content: center ;
}

.circular-chart {
  width: 100%;
  display: block;
  margin: 10px auto;
}

.circle-bg {
  fill: none;
}

.circle {
  fill: none;
  stroke-linecap: round;
}

.ready {
  animation: progress 1s ease-out forwards;
}

.splash .column:last-child {padding-top:2%!important;display:none;}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.percentage {
  text-anchor: middle;
}

.helptext {
  text-anchor: middle;
}
</style>
